<div class="notification-box" [ngClass]="{
    success: data.snackType == 'success',
    error: data.snackType == 'error',
    warning: data.snackType == 'warning'
  }">
  <div class="icon-integrate">
    <i-feather class="icon-box-circle" [name]="data.icon" *ngIf="data.showIcon"></i-feather>
  </div>
  <div class="content-integration">
    <p class="body-2 font-weight-600">{{ data.message }}</p>
    <span class="body-2 font-weight-400 underline" *ngIf="data.showButtonLink"
      (click)="linkToModule()" (keydown)="commonService.onKeyDown($event)">{{data.buttonText}}</span>
  </div>
  <div>
    <i-feather class="icon-box-circle" name="X"></i-feather>
  </div>
</div>